var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',_vm._g(_vm._b({staticClass:"tabs",attrs:{"background-color":"transparent"},on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }